import React, {useState, useEffect} from 'react'
import Grid from '@mui/material/Grid';
import { Col,Container } from 'react-bootstrap'
import Swal from 'sweetalert2' 
import { Modal, Box, Button, TextField, Alert, Checkbox, IconButton  } from "@mui/material";
import { useParams } from "react-router-dom"; 
import CloseIcon from "@mui/icons-material/Close"; 
import BackupIcon from '@mui/icons-material/Backup';

import UploadFileIcon from "@mui/icons-material/UploadFile"; 
      
const CareerDescription = () => { 
   
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    remarks: "",
    jobCategory: "",
    file: null,
  });

  const handleClose = () => {
    setOpen(false);
    setFormData({
      name: "",
      email: "",
      phone: "",
      remarks: "",
      jobCategory: "",
      file: null,
      agreedToTerms: false,
    });
  };

  const [errors, setErrors] = useState({}); 
  const [selectedPost, setSelectedPost] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false); // New state

  const validate = () => {
    let tempErrors = {};
    if (!formData.name) tempErrors.name = "Name is required.";
    if (!formData.email) tempErrors.email = "Email is required.";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      tempErrors.email = "Email is invalid.";
    if (!formData.phone) tempErrors.phone = "Phone number is required.";
    else if (!/^\d+$/.test(formData.phone))
      tempErrors.phone = "Phone number must be numeric.";

    if (!formData.jobCategory) tempErrors.jobCategory = "Job category is required";
    if (!formData.file) tempErrors.file = "Please upload your CV.";
    if (!formData.agreedToTerms)
      tempErrors.agreedToTerms = "You must agree to the terms and conditions.";
    setErrors(tempErrors); 
    return Object.keys(tempErrors).length === 0; 
  }

  // Handle text field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (formSubmitted) validate(); // Only validate after first submission
  };

  // Handle checkbox changes
  const handleCheckboxChange = (e) => {
    setFormData({ ...formData, agreedToTerms: e.target.checked });
  };

  // Handle file input changes
  const handleFileChange = (e) => {
    setFormData({ ...formData, file: e.target.files[0] });
  };
     
  // Form submission
  const handleForm = async (e) => {
    e.preventDefault(); 

    if (validate()) {
      alert("Form submitted successfully!");
      handleClose();
    }   

    const data = new FormData();
    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    data.append("remarks", formData.remarks);
    data.append("jobCategory", formData.jobCategory)
    data.append("file", formData.file);
  
    try {
      const response = await fetch("http://localhost:5000/upload", {
        method: "POST",
        body: data,
      });
  
      const result = await response.json(); 
  
      if (response.ok) {
        alert("CV uploaded successfully!");
        handleClose();
      } else {
      //  alert(`novel Error: ${result.error}`);
      } 
    } catch (error) {
      console.error("Error uploading CV:", error);
     // alert("Failed to upload CV"); 
    }
  };
   
  const { id } = useParams();
  const job = jobs.find((job) => job.id === parseInt(id));

  const responsibilities = job.responsibilities.split('/').map(item => item.trim()).filter(item => item);

  const handleSelectChange = (event) => {
    setSelectedPost(event.target.value);
    setFormData({
      ...formData,
      jobCategory: event.target.value, // Ensure it's updated in formData
    });
  };
  
            
  return (
    <>     
      <Grid  container>
        <Grid style={{ padding: "3rem 3rem 0 3rem" }} item lg={9}>
          <div className="jobLeft">

            <p className="jobLeftHeader"> {job.post} </p>
            {/* <NavLink className="" to="/career/jobs/apply">  */}
              <Button onClick={handleOpen} className='job_button' variant="danger">Apply Now</Button> 
            {/* </NavLink>  */}                
          </div> 
          <div>
            <div className='jobDetailsPara' 
              style={{
                background: "#fff",
                borderRadius: "5px",
                padding: "2rem",
              }}
            >
              <p className="roleHeader">Vacancy: {job.vacancy}</p>
              <p className="roleHeader">Job Responsibilities</p> 

              <p style={{ margin: "2rem 0", textAlign: "justify" }}>
                {/* {job.responsibilities} */}
                <ul style={{ lineHeight: '1.8' }}>
                  {responsibilities.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </p> 
   
              <p className="roleHeader">General Information</p>
              <p style={{ margin: "2rem 1rem", fontSize: "16px" }}>
                <p>
                  {" "}
                  <span style={{ fontWeight: "600" }}>Location</span> :{" "}
                  <span>Dhaka</span>
                </p>
                <p>
                  {" "}
                  <span style={{ fontWeight: "600" }}>Deadline</span> :{" "}
                  <span>2025-01-31</span>
                </p>
                <p>
                  {" "}
                  <span style={{ fontWeight: "600" }}>Position</span> :{" "}
                  <span>Mid</span>
                </p>
                <p>
                  {" "}
                  <span style={{ fontWeight: "600" }}>Salary </span> :{" "}
                  <span>Negotiable</span>
                </p>
              </p> 
   
              <p className="roleHeader">Responsibilities</p>
              <p style={{ margin: "2rem 1rem", textAlign: "justify" }}>
                <p>
                  {" "}
                  &#x2022; Must have practical knowledge to install, configure,
                  update, maintain and troubleshoot networking equipment like
                  routers (MikroTik, CISCO), switches (MikroTik, CISCO) &
                  wireless devices.{" "}
                </p>
      
                <p>
                  &#x2022; Design, implement, and maintain the company's network
                  infrastructure, including local area networks (LANs), wide
                  area networks (WANs), and wireless networks.
                </p>

                <p>
                  &#x2022; Monitor network performance and troubleshoot network
                  issues whenever it is needed on an urgent basis. Proactively
                  analyze network, application and system log events and
                  identify abnormal behavior.{" "}
                </p>

                <p>
                  &#x2022; Collaborate with the ISP to resolve network-related
                  incidents and support requests.{" "}
                </p>
              </p>

              <p className="roleHeader">Requirements</p>

              <p style={{ margin: "2rem 1rem", textAlign: "justify" }}>
                <p>
                  {" "}
                  &#x2022; 2+ years of experience in network engineering and
                  administration.{" "}
                </p>
   
                <p>
                  &#x2022; Must have good knowledge of computer hardware and
                  software.
                </p>

                <p>
                  &#x2022; Monitor network performance and troubleshoot network
                  issues whenever it is needed on an urgent basis. Proactively
                  analyze network, application and system log events and
                  identify abnormal behavior.{" "}
                </p>

                <p>
                  &#x2022; Collaborate with the ISP to resolve network-related
                  incidents and support requests.{" "}
                </p>
              </p>
   
              <p className="roleHeader"> Compensation & Benefits </p>
              <p style={{ margin: "2rem 1rem", textAlign: "justify" }}>
                <p>
                  {" "}
                  &#x2022; Awesome culture - passionate, driven and fun team.{" "}
                </p>
                <p>&#x2022; Excellent learning environment.</p>
                <p>&#x2022; Daylight shifts. </p>
                <p>
                  &#x2022; Fully subsidized lunch, snacks, and unlimited
                  tea/coffee.{" "}
                </p>
                <p>&#x2022; Ability to grow and build a career. </p>
              </p>
            </div>
          </div>
        </Grid>
   
        <Grid className='gridLeft' item lg={3}>
          <div className="recentJobs"> 

            <h2>Recent Jobs</h2>

            {jobs.map((newJob, index) => {
              const isHighlighted = newJob.post === job.post;

              return (
                <Col sm={12} md={6} lg={4} key={index}>
                  <div className={`jobBox2 ${isHighlighted ? "highlighted" : ""}`}>
                    <a href={`/jobs/${newJob.id}`} rel="noopener noreferrer" className="jobHeader2">
                      {newJob.post}
                    </a>
                  </div>
                </Col>
              );
            })} 

          </div>
        </Grid>
      </Grid>
     
      <Container
        style={{ marginTop: "2rem", background: "#fff" }}
        fluid="true"
        className=" copyrightSection text-center"
      >
        <a
          style={{ color: "#000", fontWeight: "500" }}
          className="copyrightText"
          href="#"
        >
          &copy; Copyright{" "}
          <strong style={{ color: "#1dc6ad" }}> Talukder </strong> Group Of
          Industries {new Date().getFullYear()}
        </a>
      </Container> 
     
  <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="upload-modal-title"
      aria-describedby="upload-modal-description"
    >    
      <form onSubmit={handleForm} encType="multipart/form-data">
        <Box
          sx={{
           // width: { xs: "90%", sm: "70%", md: "50%", lg: "30%" }, 
            width: "40vw",   
            margin: "50px auto", 
            padding: "20px", 
            backgroundColor: "#fff",
            borderRadius: "8px",
            boxShadow: 24,
            overflow: "auto",
            maxHeight: "90vh",
            position: "relative"
          }}
        >
        
            {/* Close Button in Top Right */}
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: "20px",
                right: "20px",
                color: "#fff",
                background: "#a6a6a6"
              }}
            >
              <CloseIcon />
            </IconButton>
         
          <h2 id="upload-modal-title" style={{ textAlign: "center" }}>
            Upload Your CV
          </h2>
          <p id="upload-modal-description" style={{ textAlign: "center" }}>
            Fill in the form and upload your CV below.
          </p>
   
          {/* Name Field */} 
          <TextField   
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />

{errors.name && <Alert severity="warning">{errors.name}</Alert>}
     
          {/* Email Field */}
          <TextField
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          
{errors.email && <Alert severity="warning">{errors.email}</Alert>}


          {/* Phone Field */}
          <TextField
            label="Phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />

{errors.phone && <Alert severity="warning">{errors.phone}</Alert>}


          {/* select dropdown */}    
   
            <select
              value={selectedPost}
              onChange={handleSelectChange}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ddd",
                borderRadius: "5px",
                color: "#404040"
              }}
            >
              <option style={{ color: "#999999" }} value="">
                -- Select a Job Post --
              </option>
              {jobs.map((job) => (
                <option key={job.id} value={job.post}>
                  {job.post}
                </option>
              ))}
            </select> 

{errors.jobCategory && <Alert severity="warning">{errors.jobCategory}</Alert>}

    
          {/* Remarks Field */}
          <TextField
            label="Remarks"
            name="remarks"
            value={formData.remarks}
            onChange={handleChange}
            fullWidth
            multiline
            rows={2}
            margin="normal"
            inputProps={{ maxLength: 50 }}
          />
       
            {/* File Upload */}
            <Button className='chooseFileButton' component="label" 
            style={{ margin: "10px 0", display: "block", textAlign: "center", border: "2px solid #808080", borderStyle: "dashed", padding: "1rem 0", background: "#f2f2f2" }}>
             
              <label htmlFor="file-upload"> 
                <input
                  id="file-upload"
                  type="file" 
                  name="file" 
                  style={{ display: "none" }} 
                  onChange={handleFileChange} 
                /> 
                <IconButton component="span">
                  <BackupIcon style={{ fontSize: 30, color: "#000" }} /> 
                </IconButton>

                <p style={{fontFamily: "Poppins", fontSize:"16px", color: "#595959"}}>Upload Your CV (Max 500KB)</p> 
              </label>

          </Button> 
                           
          {formData.file && <p>Selected File: {formData.file.name}</p>}
          {errors.file && <Alert severity="warning">{errors.file}</Alert>} 

          {/* Terms and Conditions Checkbox */}
          <label style={{ display: "block", margin: "10px 0", fontSize:"20px" }}> 
            <input
              type="checkbox"
              checked={formData.agreedToTerms}
              onChange={handleCheckboxChange}
              style={{ marginRight: "8px", fontSize:"20px" }}
            />
            I agree to the terms and conditions
          </label>
          {errors.agreedToTerms && (
            <Alert severity="warning">{errors.agreedToTerms}</Alert>
          )}
                  
          {/* Submit Button */}
          <Button style={{marginBottom: "10px", padding: "10px", fontSize: "18px", background: "#17a2b8", borderRadius: "30px"}} variant="contained" type="submit" fullWidth>
            Submit
          </Button> 
        </Box> 
      </form>
    </Modal> 
     
    </> 
  ); 
} 
   
export default CareerDescription

const jobs = [
  // {
  //   id: 1,
  //   post: "Software Engineer",   
  //   dept: "Information Technology",
  //   vacancy: "5",
  //   responsibilities: "3 years of experiences in related field/Excellent Email & Verbal Communication/Proficiency in MS Word, Excel, Power Point, Drafting Critical issue solving/Knowledge in Real Estate sector, land Possession Takeover, Construction, Design & DAP/Experience in Customer Service, Negotiation, Critical customer dealing, Troubleshooting",
  //   status: "Full-time",
  //   workplace: "Work at office",
  //   education: "Graduation from reputed university",
  //   experience: "3 years of experiences in related field/Excellent Email & Verbal Communication/Proficiency in MS Word, Excel, Power Point, Drafting Critical issue solving/Knowledge in Real Estate sector, land Possession Takeover, Construction, Design & DAP/Experience in Customer Service, Negotiation, Critical customer dealing, Troubleshooting/3 years of experiences in related field/Incumbent should have excellent contacts and relation maintaining capability/A sophisticated personality and a proven track record of success in logistic related assignment is necessary for this position/Experienced in logistic management ",
  //   salary: "35000",
  //   benefits : "",
  // },
  // {
  //   id: 2,
  //   post: "HR Manager",
  //   dept: "Human Resource",
  //   vacancy: "3",
  //   responsibilities: "10 years of experiences in Manager at HRM", 
  //   status: "Full-time",
  //   workplace: "Work at office",
  //   education: "Graduation from reputed university",
  //   experience: "10 years of experiences in Manager at HRM",
  //   salary: "35000",
  //   benefits : "",
  // },
  // {
  //   id: 3,
  //   post: "Sales Admin ",
  //   dept: "UPVC",
  //   vacancy: "10",
  //   responsibilities: "5 years of experiences in Sales Admin",
  //   status: "Full-time",
  //   workplace: "Work at office",
  //   education: "Graduation from reputed university",
  //   experience: "3 years of experiences in related field/Excellent Email & Verbal Communication/Proficiency in MS Word, Excel, Power Point, Drafting Critical issue solving/Knowledge in Real Estate sector, land Possession Takeover, Construction, Design & DAP/Experience in Customer Service, Negotiation, Critical customer dealing, Troubleshooting/3 years of experiences in related field/Incumbent should have excellent contacts and relation maintaining capability/A sophisticated personality and a proven track record of success in logistic related assignment is necessary for this position/Experienced in logistic management ",
  //   salary: "15000",
  //   benefits : "",
  // },
]; 

